import { i18n } from './i18n';
var icuRelatedOptions = ['icuOptions', 'parseErrorHandler', 'polyfillRelativeTime'];
export function initI18nWithoutICU(options) {
  var incorrectOptions = icuRelatedOptions.filter(function (option) {
    return typeof options[option] !== 'undefined';
  });

  if (incorrectOptions.length) {
    throw new Error("Can't use " + incorrectOptions + " with 'initI18nWithoutICU'. Please, use 'initI18n' function.");
  }

  return i18n(options);
}